import "./SingleBusinessDirectoryTemplate.module.css"
import Header from "@/reusable_sections/Header"
import SingleBusinessDirectoryTemplateSection from "./sections/SingleBusinessDirectoryTemplateSection"
import Footer from "@/reusable_sections/Footer"

export default function SingleBusinessDirectoryTemplatePage() {

  return (
    <div>
      <Header />
      <SingleBusinessDirectoryTemplateSection />
      <Footer />
    </div>
  )
}
